
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/[slug]",
      function () {
        return require("private-next-pages/perfil/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perfil/[slug]"])
      });
    }
  